export default __webpack_public_path__ + "static/media/logo-main.69eafef5.png";